module.exports = __webpack_public_path__ + "img/two-person.f47745e2.png";